import { Dayjs } from 'dayjs';

const DAYS_IN_WEEK = 7;

export type PriorPeriod = {
  start: Dayjs;
  end: Dayjs;
  comparisonLabel: string;
};

/**
 * The comparison window is the same length as the selected range and sits
 * immediately before it. A full calendar month compares with the previous
 * calendar month, so October is measured against September.
 */
export const getPriorPeriod = (
  rangeStart: Dayjs,
  rangeEnd: Dayjs,
): PriorPeriod => {
  const start = rangeStart.startOf('day');
  const end = rangeEnd.startOf('day');
  const isCalendarMonth =
    start.isSame(start.startOf('month'), 'day') &&
    end.isSame(start.endOf('month'), 'day');

  if (isCalendarMonth) {
    const previousMonth = start.subtract(1, 'month');
    return {
      start: previousMonth.startOf('month'),
      end: previousMonth.endOf('month'),
      comparisonLabel: 'from prior month',
    };
  }

  const rangeLengthDays = end.diff(start, 'day') + 1;
  const priorEnd = start.subtract(1, 'day');
  const priorStart = priorEnd.subtract(rangeLengthDays - 1, 'day');

  let comparisonLabel = `from previous ${rangeLengthDays} days`;
  if (rangeLengthDays === 1) {
    comparisonLabel = 'from previous day';
  } else if (rangeLengthDays === DAYS_IN_WEEK) {
    comparisonLabel = 'from prior week';
  }

  return {
    start: priorStart.startOf('day'),
    end: priorEnd.endOf('day'),
    comparisonLabel,
  };
};
